import React from 'react';

export default function Fleet() {
    return(
        <div className="Fleet">Test content for Fleet page</div>
    );
}